import { jsx, jsxs } from 'react/jsx-runtime';
import { AnimatePresence } from 'framer-motion';
import { ExtraPanelSidebar } from '../ExpandedResource/ExtraPanel/Sidebar.js';
import { MessagesProvider } from '../../../assistant/hooks/useChatbot.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { AssistantHeader } from '../../../assistant/components/AssistantHeader.js';
import { P } from '@fabric-app/ui/components/Typography';
import MessagesList from '../../../assistant/components/Chatbot/MessageList.js';
import MessageForm from '../../../assistant/components/Chatbot/MessageForm.js';
import { ForcedTheme } from '@fabric-app/ui/theme/ForcedTheme';
import { forwardRef } from 'react';
import { DialogPortal, DialogContent } from '@radix-ui/react-dialog';
import { IconNavigational24Shrink } from '@fabric-app/icons/svg';
import { useAssistantStore } from '../../../assistant/stores/assistantStore.js';

const ExpandedFdocSidebarAssistant = /* @__PURE__ */ forwardRef(({ isFullscreen, resourceId, canAutoFocus }, ref) => {
  const { chatAssistantFullscreen, setChatAssistantFullscreen } = useAssistantStore();
  const content = /* @__PURE__ */ jsxs(MessagesProvider, {
    chatAssistantOpen: true,
    expandedResourceId: resourceId,
    children: [
      /* @__PURE__ */ jsxs(Flex, {
        direction: "column",
        style: {
          position: "relative",
          overflow: "hidden"
        },
        ref,
        flexGrow: 1,
        children: [
          /* @__PURE__ */ jsxs(AssistantHeader.Root, {
            children: [
              /* @__PURE__ */ jsxs(AssistantHeader.Left, {
                children: [
                  /* @__PURE__ */ jsx(P, {
                    size: "xs",
                    children: "Context:"
                  }),
                  /* @__PURE__ */ jsx(AssistantHeader.ContextSelector, {})
                ]
              }),
              /* @__PURE__ */ jsxs(Flex, {
                gap: 10,
                children: [
                  /* @__PURE__ */ jsx(AssistantHeader.ResetButton, {}),
                  !chatAssistantFullscreen && /* @__PURE__ */ jsx(AssistantHeader.FullScreenButton, {
                    onClick: () => setChatAssistantFullscreen(true)
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx(MessagesList, {
            style: {
              paddingBottom: isFullscreen ? 0 : void 0
            }
          })
        ]
      }),
      /* @__PURE__ */ jsx(AnimatePresence, {
        initial: false,
        children: /* @__PURE__ */ jsx(MessageForm, {
          autoFocus: canAutoFocus
        })
      })
    ]
  });
  return chatAssistantFullscreen ? /* @__PURE__ */ jsx(DialogPortal, {
    children: /* @__PURE__ */ jsx(ForcedTheme, {
      colorScheme: "dark",
      children: /* @__PURE__ */ jsx(DialogContent, {
        "aria-describedby": void 0,
        children: /* @__PURE__ */ jsxs(ExtraPanelSidebar.Root, {
          isFullscreen: true,
          children: [
            /* @__PURE__ */ jsxs(ExtraPanelSidebar.Header, {
              children: [
                /* @__PURE__ */ jsx(ExtraPanelSidebar.FullScreenTitle, {
                  children: "Fabric assistant"
                }),
                /* @__PURE__ */ jsx(ExtraPanelSidebar.FullScreenButtonsContainer, {
                  children: /* @__PURE__ */ jsx(ExtraPanelSidebar.FullScreenIconButton, {
                    onClick: () => setChatAssistantFullscreen(false),
                    children: /* @__PURE__ */ jsx(IconNavigational24Shrink, {})
                  })
                })
              ]
            }),
            content
          ]
        })
      })
    })
  }) : content;
});
ExpandedFdocSidebarAssistant.displayName = "ExpandedFdocSidebarAssistant";

export { ExpandedFdocSidebarAssistant as default };
//# sourceMappingURL=ExpandedFdoc__Assistant.js.map
